import React, { useState } from "react"

export const Select = ({ options, onChange }) => {
  const [selectedOption, setSelectedOption] = useState(options[0])

  const handleOptionSelect = (event) => {
    const { value } = event.target
    const selected = options.find((option) => option === value)
    setSelectedOption(selected)
    onChange(selected)
  }

  return (
    <div className="select">
      <select value={selectedOption} onChange={handleOptionSelect}>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  )
}
